module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('group', {
    attrs: {
      "title": "cell demo"
    }
  }, [_c('cell', {
    attrs: {
      "title": "VUX",
      "value": "cool",
      "is-link": ""
    }
  }, [_c('span', {
    staticClass: "iconfont icon-all"
  })]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "width": "94%"
    },
    nativeOn: {
      "click": function($event) {
        _vm.goc($event)
      }
    }
  }, [_vm._v("CusChild")]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "width": "94%"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gobase($event)
      }
    }
  }, [_vm._v("基地列表")]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "width": "94%"
    },
    nativeOn: {
      "click": function($event) {
        _vm.god($event)
      }
    }
  }, [_vm._v("发货记录")]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "width": "94%"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gobus($event)
      }
    }
  }, [_vm._v("将用户信息打印到控制台")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-demo"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/vux_logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89c62588"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 153
// module chunks = 15